<template>
  <div>
    <div class="columns">
      <div class="column is-narrow">
        <b-field label="Ersetzung">
        <table style="width:auto;">
          <tr v-for="letter in alphabet" :key="'row-' + letter">
            <td>{{ letter }}</td>
            <td>
              <input type="text" size="1" maxlength="1" v-model="subst[letter]"
                     class="is-uppercase" />
            </td>
          </tr>
        </table>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Eingabetext">
          <b-input type="textarea" v-model.trim="text" custom-class="is-uppercase" />
        </b-field>
        <b-message v-if="duplicates.length > 0" type="is-warning">
          Achtung: Folgenden Buchstaben sind doppelt vergeben:
          <ul>
            <li v-for="dup in duplicates" :key="'dup-' + dup.letter">
              {{ dup.others.join(', ') }} -&gt; {{ dup.letter }}
            </li>
          </ul>
        </b-message>
      </div>
      <div class="column" style="word-break:break-all;">
      <b-field label="Substituierter Text">
        <div>
          <span v-for="(textPart, i) in substText" :key="'textPart-' + i"
                :style="{color: textPart.isSub ? '#00d' : '#000'}"
          >{{ textPart.text }}</span>
        </div>
      </b-field>
      </div>
    </div>
  </div>
</template>

<script>
const alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
                 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
export default {
  data () {
    let subst = {}
    alphabet.forEach(function(letter) {
      subst[letter] = letter
    })
    return {
      text: '',
      subst: subst,
      alphabet: alphabet
    }
  },
  computed: {
    substText() {
      let text = this.text.toUpperCase()
      let result = []
      for (let i = 0; i < text.length; i++) {
        let letter = text[i]
        if (this.subst.hasOwnProperty(letter) && alphabet.indexOf(this.subst[letter].toUpperCase()) !== -1) {
          result.push({
            isSub: letter !== this.subst[letter].toUpperCase(),
            letter: this.subst[letter].toUpperCase()
          })
        } else {
          result.push({
            isSub: false,
            letter: letter
          })
        }
      }
      let retval = []
      let buf = []
      let wasSub = false
      for (let i = 0; i < result.length; i++) {
        let x = result[i]
        if (x.isSub !== wasSub) {
          if (buf.length > 0) {
            retval.push({
              isSub: wasSub,
              text: buf.join('')
            })
            buf = []
          }
        }
        buf.push(x.letter)
        wasSub = x.isSub
      }
      if (buf.length > 0) {
        retval.push({
          isSub: wasSub,
          text: buf.join('')
        })
      }
      return retval
    },
    duplicates() {
      let seen = {}
      let dups = []
      for (let letter in this.subst) {
        let s = this.subst[letter].toUpperCase()
        if (seen.hasOwnProperty(s)) {
          dups.push({
            letter: s,
            others: seen[s]
          })
        } else {
          seen[s] = []
        }
        seen[s].push(letter)
      }
      return dups
    }
  }
}
</script>
